import "core-js/modules/es6.function.name";
import _Card2 from "element-ui/lib/theme-chalk/card.css";
import "element-ui/lib/theme-chalk/base.css";
import _Card from "element-ui/lib/card";
import _MenuItem2 from "element-ui/lib/theme-chalk/menu-item.css";
import "element-ui/lib/theme-chalk/base.css";
import _MenuItem from "element-ui/lib/menu-item";
import _Submenu2 from "element-ui/lib/theme-chalk/submenu.css";
import "element-ui/lib/theme-chalk/base.css";
import _Submenu from "element-ui/lib/submenu";
import _Menu2 from "element-ui/lib/theme-chalk/menu.css";
import "element-ui/lib/theme-chalk/base.css";
import _Menu from "element-ui/lib/menu";
import _Button2 from "element-ui/lib/theme-chalk/button.css";
import "element-ui/lib/theme-chalk/base.css";
import _Button from "element-ui/lib/button";
import _TabPane2 from "element-ui/lib/theme-chalk/tab-pane.css";
import "element-ui/lib/theme-chalk/base.css";
import _TabPane from "element-ui/lib/tab-pane";
import _Tabs2 from "element-ui/lib/theme-chalk/tabs.css";
import "element-ui/lib/theme-chalk/base.css";
import _Tabs from "element-ui/lib/tabs";
import _Input2 from "element-ui/lib/theme-chalk/input.css";
import "element-ui/lib/theme-chalk/base.css";
import _Input from "element-ui/lib/input";
import _Option2 from "element-ui/lib/theme-chalk/option.css";
import "element-ui/lib/theme-chalk/base.css";
import _Option from "element-ui/lib/option";
import _Select2 from "element-ui/lib/theme-chalk/select.css";
import "element-ui/lib/theme-chalk/base.css";
import _Select from "element-ui/lib/select";
import _DatePicker2 from "element-ui/lib/theme-chalk/date-picker.css";
import "element-ui/lib/theme-chalk/base.css";
import _DatePicker from "element-ui/lib/date-picker";
import "/app/node_modules/core-js/modules/es6.array.iterator.js";
import "/app/node_modules/core-js/modules/es6.promise.js";
import "/app/node_modules/core-js/modules/es6.object.assign.js";
import "/app/node_modules/core-js/modules/es7.promise.finally.js";
import Vue from "vue";
import "normalize.css/normalize.css"; // A modern alternative to CSS resets
import "./styles/index.scss"; // global css
import App from "./App";
import store from "./store";
import router from "./router";
import "@/permission"; // permission control
import { parseTime } from "./utils";
import VueQr from "vue-qr";
import bycardUi from "luu-ui";
import { zhLang } from "luu-ui/lib/locale-zh";
import { enLang } from "luu-ui/lib/locale-en";
import "luu-ui/lib/resize";
import "luu-ui/lib/theme/index.css";
import DateRange from "./components/DateRange";
import ExcelExport from "./components/ExcelExport";
import i18n from "./i18n";
Vue.component("vue-qr", VueQr);
Vue.use(_DatePicker);
Vue.use(_Select);
Vue.use(_Option);
Vue.use(_Input);
Vue.use(_Tabs);
Vue.use(_TabPane);
Vue.use(_Button);
Vue.use(_Menu);
Vue.use(_Submenu);
Vue.use(_MenuItem);
Vue.use(_Card);
Vue.component(DateRange.name, DateRange);
Vue.component(ExcelExport.name, ExcelExport);
Vue.use(bycardUi, {
  getLang: function getLang() {
    return i18n.locale === "en" ? enLang : zhLang;
  }
});
Vue.config.productionTip = false;
Vue.filter("formatTime", function (val) {
  return parseTime(val, "{y}.{m}.{d} {h}:{i}:{s}");
});
new Vue({
  el: "#app",
  router: router,
  store: store,
  i18n: i18n,
  render: function render(h) {
    return h(App);
  }
});